import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Login_page from './Login/login_page';
import Addresspage from "./Addresspage/Addresspage";
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import IcsLink from './Ics-calender/createIcsLink';
import ProtectedRoute from './ProtectedRoute';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>

        {/* Öffentliche Route */}
        <Route path="/login" element={<Login_page />} />

        {/* Geschützte Routen */}
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<App />} />
          <Route path="/calendar" element={<App />} />
          <Route path="/contact" element={<Addresspage />} />
          <Route path="/createIcsLink" element={<IcsLink />} />
        </Route>

      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
